import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    root:{
        marginLeft:'20%',
        marginRight:'20%',
        marginTop:theme.spacing(6),
    },
}));
